<template>
  <div>
    <form autocomplete="no" @submit.prevent="$emit('save')" @keydown="clearError($event)">
      <div id="accordion-wrap">
        <div class="mobile-accordion">
          <div
            class="card-header"
            id="headingOne"
            data-toggle="collapse"
            data-target="#collapseOne"
            aria-expanded="true"
            aria-controls="collapseOne"
            @click="setOpenedAccordion(1)"
            ref="addresses"
          >
            <span class="mb-0">
              Addresses
            </span>
            <img src="../../assets/img/chevron-alt.svg" alt="chevron" class="chevron-alt" :class="{ rotate: expanded.includes(1)}" />
          </div>

          <div id="collapseOne" class="collapse" :class="{ 'show': jobTabStep === 1 }" aria-labelledby="headingOne" data-parent="#accordion-wrap">
            <!-- Show Addresses -->
            <section>
              <div class="row mb-4">
                <jobs-leads-addresses :data="job"
                                      :has-access="hasAccess"
                                      :show-dropdown="showDropdown"
                                      :permission="'jobs.route.update'"
                                      :errors="errors"
                                      @toggleEditField="toggleEditField"
                                      @setAddress="setAddress"
                                      @switchRoute="switchRoute"
                                      @addAddress="addAddress"
                                      @removeAddress="removeAddress"
                />
              </div>

              <AreYouSureDeleteFile
                v-if="fileForDelete !== null"
                :job="job"
                :file="fileForDelete"
                @close="fileForDelete = null"
                @reload-files="getFiles"
              />

              <div class="row mb-3">
                <div class="col-12">
                  <h2 class="mt-4 mb-2 documents-title">Documents</h2>
                </div>
                <div v-if="job.agreements.length" class="col-12 pr-0 pb-3 border-bottom">
                  <div class="flex flex-wrap">
                    <div @click="openFile(agreement.url)" v-for="agreement in job.agreements" :key="agreement.id" class="d-flex flex cursor-pointer justify-content-center align-items-start mr-2 pt-2 px-2 border rounded file-card">
                      <span class="mod-icon-doc mt-1" />
                      <div class="d-flex flex-column ml-1">
                        <span class="file-name">{{ agreement.url.substring(agreement.url.lastIndexOf('/')+1) }}</span>
                        <span class="file-date">{{ agreement.date }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 pr-0 mt-3">
                  <div class="d-flex align-items-start justify-content-start flex-wrap">
                    <div class="mb-3">
                      <UploadDocument :model-id="job.id" @uploaded="getFiles" />
                    </div>

                    <div v-for="file in files.filter(file => !file.uploaded_by_customer)" :key="file.id" class="d-flex flex cursor-pointer justify-content-center align-items-start mr-2 pt-2 px-2 border rounded file-card">
                      <span @click="openFile(file.url)" :class="{'mod-icon-doc mt-1': !file.mime.includes('image'), 'mod-icon-img': file.mime.includes('image')}" class="" />
                      <div @click="openFile(file.url)" class="d-flex flex-column ml-1">
                        <span class="file-name">{{ file.name }}</span>
                        <span class="file-date">{{ file.date }}</span>
                      </div>
                      <div class="d-flex align-items-center ml-3" style="height: 40px">
                        <span :class="{'mod-icon-eye-state': file.can_see_customer, 'mod-icon-eye-off-state': !file.can_see_customer}" />
                      </div>
                      <div class="buttons-box">
                        <div @click.prevent="updateFileCanCustomerSee(file)" class="d-flex align-items-center justify-content-center mx-1 ml-3">
                          <span :class="{'mod-icon-eye': !file.can_see_customer, 'mod-icon-eye-off': file.can_see_customer}" />
                        </div>
                        <div @click.prevent="fileForDelete = file" class="mx-1 remove-file-block">
                          <span class="mod-icon-remove-file" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="files.filter(file => file.uploaded_by_customer).length > 0" class="col-12 pr-0 mt-3 pt-3 border-top">
                  <h2 class="mb-2 documents-title">Uploaded by customer</h2>

                  <div class="d-flex align-items-start justify-content-start flex-wrap">
                    <div v-for="file in files.filter(file => file.uploaded_by_customer)" :key="file.id" class="d-flex flex cursor-pointer justify-content-center align-items-start mr-2 pt-2 px-2 border rounded file-card">
                      <span @click="openFile(file.url)" :class="{'mod-icon-doc mt-1': !file.mime.includes('image'), 'mod-icon-img': file.mime.includes('image')}" class="" />
                      <div @click="openFile(file.url)" class="d-flex flex-column ml-1">
                        <span class="file-name">{{ file.name }}</span>
                        <span class="file-date">{{ file.date }}</span>
                      </div>
                      <div class="buttons-box">
                        <div @click.prevent="fileForDelete = file" class="mx-1 ml-3 remove-file-block">
                          <span class="mod-icon-remove-file" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>

        <div class="mobile-accordion">
          <div
            class="card-header"
            id="headingTwo"
            data-toggle="collapse"
            data-target="#collapseTwo"
            aria-expanded="true"
            aria-controls="collapseTwo"
            @click="setOpenedAccordion(2)"
            ref="location"
          >
            <span class="mb-0">
              Location details
            </span>
            <img src="../../assets/img/chevron-alt.svg" alt="chevron" class="chevron-alt" :class="{ rotate: expanded.includes(2) }" />
          </div>

          <div id="collapseTwo" class="collapse" :class="{ 'show': jobTabStep === 2 }" aria-labelledby="headingTwo" data-parent="#accordion-wrap">
            <!-- Show location details -->
            <section>
              <div class="row mb-3">
                <div class="map-job-wrapper col-lg-5 col-xl-6 pr-0">
                  <JobsMapConnectionIssue v-if="showDisconnectError" />
                  <div v-show="!mapLoading" id="mapid" style="width: 480px; height: 500px" />
                  <div v-if="mapLoading" class="loader-circle" />
                </div>
                <div class="col-lg-7 col-xl-6 mt-4 mt-lg-0 mt-md-0 mt-xl-0">
                  <Distance
                    :distance="job.distances"
                  />
                  <JobInProgressMoveTimeline
                    v-if="showTimeline"
                    :status-id="job.status_id"
                    :status-logs="job.status_logs"
                    :status-name="job.status.name"
                  />
                </div>
              </div>
            </section>
          </div>
        </div>

        <div class="mobile-accordion">
          <div
            class="card-header"
            id="headingThree"
            data-toggle="collapse"
            data-target="#collapseThree"
            aria-expanded="true"
            aria-controls="collapseThree"
            @click="setOpenedAccordion(3)"
            ref="movers"
          >
            <span class="mb-0">
              Movers & Trucks
            </span>
            <img src="../../assets/img/chevron-alt.svg" alt="chevron" class="chevron-alt" :class="{ rotate: expanded.includes(3) }" />
          </div>

          <div id="collapseThree" class="collapse" :class="{ 'show': jobTabStep === 3 }" aria-labelledby="headingThree" data-parent="#accordion-wrap">
            <!-- Show movers and trucks -->
            <section class="movers-truck-info">
              <template v-if="hasAccess">
                <div>
                  <div class="row mb-3">
                    <div class="col-12 col-xl-6 col-md-6 col-lg-6 movers-message">
                      <h2 class="l-header-2">
                        <span class="mod-icon mod-icon-groups-dark" />
                        MOVERS
                        <span class="movers-truck-count">
                          {{ Object.keys(job.assigned_movers).length }}</span>
                      </h2>
                      <div class="message-wrap pull-right"
                           @mouseover="showTooltipPrefix = true"
                           @mouseout="showTooltipPrefix = false"
                      >
                        <div class="btn send-to-all-box pull-right pointer"
                             v-if="isActive"
                             :class="{'disabled': !Object.keys(job.assigned_movers).length || !carrierPhoneNumberCheck()}"
                             @click="$emit('sendAutomaticMessages', (Object.keys(job.assigned_movers).length && true))"
                        >
                          <span class="send-to-all">A</span>
                          <span class="send-to-all-text">Send to all</span>
                        </div>
                      </div>
                      <div class="popover tippy-info-popover"
                           v-if="showTooltipPrefix && !Object.keys(job.assigned_movers).length"
                      >
                        There are no movers assigned on this job, messages cannot be sent
                      </div>
                      <div class="popover tippy-info-popover company-number-popup"
                           v-if="showTooltipPrefix && !carrierPhoneNumberCheck()"
                      >
                        Company doesn’t have a phone number for sending SMS to movers
                      </div>
                      <table class="table m-table table-hover"
                             v-if="job.assigned_movers.length"
                      >
                        <thead>
                          <tr>
                            <th scope="col" class="pl-0">Name</th>
                            <th scope="col" class="pl-0">Status</th>
                            <th scope="col" class="pl-0" />
                            <th scope="col" class="pl-0">Phone</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(assigned_mover, index) in job.assigned_movers"
                              :key="assigned_mover.id"
                          >
                            <td class="pl-0">
                              {{ assigned_mover.first_name }} {{ assigned_mover.last_name }}
                              <span v-if="assigned_mover.id === job.foreman_id"
                                    :class="{'foreman-status-blue': assigned_mover.id === job.foreman_id}"
                              >F</span>
                              <span v-else-if="assigned_mover.foreman === true"
                                    :class="{'foreman-status-grey': 'assigned_mover.foreman === true'}"
                              >F</span>
                            </td>
                            <td class="pl-0"
                                v-if="job.assigned_movers !== ''"
                            >
                              <span class="message-status message-pending"
                                    v-if="job.assigned_movers[index].confirmed === 'pending'"
                              >
                                <span class="send-to-all">A</span>
                                <span class="message-text message-pending-text">Pending</span>
                              </span>
                              <span class="message-status message-declined"
                                    v-if="job.assigned_movers[index].confirmed === 'declined'"
                              >
                                <span class="send-to-all">A</span>
                                <span class="message-text message-text">Declined</span>
                              </span>
                              <span class="message-status message-confirmed"
                                    v-if="job.assigned_movers[index].confirmed === 'confirmed'"
                              >
                                <span class="send-to-all">A</span>
                                <span class="message-text message-text">Confirmed</span>
                              </span>
                            </td>
                            <td class="pl-0">
                              <div class="dot-blue dot-blue-small pointer"
                                   @click="toggleShowMessagesModal(assigned_mover.id)"
                                   v-if="assigned_mover.has_new_message === true"
                              />
                            </td>
                            <td class="pl-0">
                              {{ phoneMask.maskedPhone(assigned_mover.phone) }}
                            </td>
                            <td class="pr-0 new-message-open align-items-center">
                              <template
                                v-if="isActive"
                              >
                                <div class="send-to-mover"
                                     @mouseover="showTooltipMoversPrefix = index"
                                     @mouseout="showTooltipMoversPrefix = false"
                                >
                                  <div class="message-send-to-all pointer"
                                       v-if="!loadingButtonMovers[index]"
                                       @click="sendMessages(assigned_mover, index)"
                                       :class="[{'running': loadingButtonMovers[index]},
                                                {'disabled':!assigned_mover.phone || !carrierPhoneNumberCheck()}]"
                                  >
                                    <span class="send-to-all">A</span>
                                  </div>
                                  <div class="ld ld-ball ld-flip send-messages-icon-loader"
                                       v-else
                                  />
                                </div>
                              </template>
                              <div class="send-to-all-modal"
                                   @mouseover="showTooltipMoversPrefix = index"
                                   @mouseout="showTooltipMoversPrefix = false"
                              >
                                <div class="message-send-to-all pointer"
                                     @click="toggleShowMessagesModal(assigned_mover.id)"
                                     :class="{'disabled': !assigned_mover.phone || !carrierPhoneNumberCheck()}"
                                >
                                  <span class="send-to-all"><i class="fa fa-ellipsis-h" /></span>
                                </div>
                              </div>
                              <button v-if="isActive || (isCompleted && $_can('movers.completed_job.edit'))"
                                      type="button"
                                      class="btn btn-clear pointer pull-right"
                                      @click="unassignMover(assigned_mover.id)"
                              >
                                <span class="mod-icon-clear" />
                              </button>
                              <div class="popover tippy-info-popover"
                                   v-if="showTooltipMoversPrefix === index && !carrierPhoneNumberCheck()"
                              >
                                Company doesn’t have a phone number for sending SMS to movers
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="col-12 col-xl-6 col-md-6 col-lg-6">
                      <h2 class="l-header-2">
                        <span class="mod-icon mod-icon-trucks-dark" />
                        TRUCKS
                        <span class="movers-truck-count">
                          {{ Object.keys(job.assigned_trucks).length }}</span>
                      </h2>
                      <table class="table m-table"
                             v-if="job.assigned_trucks.length"
                             :class="{'table-hover': isActive}"
                      >
                        <thead>
                          <tr>
                            <th scope="col" class="pl-0">Licence plate</th>
                            <th scope="col" class="pl-0">Name</th>
                            <th scope="col" />
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="assigned_truck in job.assigned_trucks"
                              :key="assigned_truck.id"
                          >
                            <td class="pl-0">{{ assigned_truck.licence_plate }}</td>
                            <td class="pl-0">{{ assigned_truck.name }}</td>
                            <td class="pr-0">
                              <button v-if="isActive"
                                      type="button"
                                      class="btn btn-clear pointer pull-right"
                                      @click="unassignTruck(assigned_truck.id)"
                              >
                                <span class="mod-icon-clear" />
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col-12 col-xl-6 col-md-6 col-lg-6"
                      v-if="isActive || (isCompleted && $_can('movers.completed_job.edit'))"
                    >
                      <button type="button" class="add-button pointer"
                              @click="$emit('openAssignedMoversModal')"
                      >
                        <span class="mr-2"><span class="mod-icon-add" /></span>
                        Assign Mover
                      </button>
                    </div>
                    <div class="col-12 col-xl-6 col-md-6 col-lg-6 mt-3 mt-lg-0 mt-xl-0 mt-md-0" v-if="isActive">
                      <button type="button" class="add-button pointer"
                              @click="$emit('openAssignedTrucksModal')"
                      >
                        <span class="mr-2"><span class="mod-icon-add" /></span>
                        Assign Truck
                      </button>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="row">
                  <div class="container">
                    <div class="col-12 d-flex flex-column align-items-center justify-content-center">
                      <div class="access-image">
                        <NoAccessImage />
                      </div>
                      <div>
                        Sorry, you don't have access to this information.
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </section>
          </div>
        </div>

        <div class="mobile-accordion">
          <div
            class="card-header"
            id="headingFive"
            data-toggle="collapse"
            data-target="#collapseFive"
            aria-expanded="true"
            aria-controls="collapseFive"
            @click="setOpenedAccordion(5)"
            ref="plans"
          >
            <span class="mb-0">
              Plans
            </span>
            <img src="../../assets/img/chevron-alt.svg" alt="chevron" class="chevron-alt" :class="{ rotate: expanded.includes(4) }" />
          </div>

          <div id="collapseFive" class="collapse" :class="{ 'show': jobTabStep === 5 }" aria-labelledby="headingFive" data-parent="#accordion-wrap" v-if="jobTabStep === 5">
            <!-- Show plans -->
            <section>
              <template v-if="hasAccess">
                <div class="row mb-3">
                  <div class="col-12">
                    <JobPlans :job="job" @getJob="$emit('getJob')" />
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="row">
                  <div class="container">
                    <div class="col-12 d-flex flex-column align-items-center justify-content-center">
                      <div class="access-image">
                        <NoAccessImage />
                      </div>
                      <div>
                        Sorry, you don't have access to this information.
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </section>
          </div>
        </div>

        <div class="mobile-accordion">
          <div
            class="card-header"
            id="headingFour"
            data-toggle="collapse"
            data-target="#collapseFour"
            aria-expanded="true"
            aria-controls="collapseFour"
            @click="setOpenedAccordion(4)"
            ref="log"
          >
            <span class="mb-0">
              Log
            </span>
            <img src="../../assets/img/chevron-alt.svg" alt="chevron" class="chevron-alt" :class="{ rotate: expanded.includes(4) }" />
          </div>

          <div id="collapseFour" class="collapse" :class="{ 'show': jobTabStep === 4 }" aria-labelledby="headingFour" data-parent="#accordion-wrap" v-if="jobTabStep === 4">
            <!-- Show log -->
            <section>
              <template v-if="hasAccess">
                <div class="row mb-3">
                  <div class="col-12">
                    <JobLogs :job="job" />
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="row">
                  <div class="container">
                    <div class="col-12 d-flex flex-column align-items-center justify-content-center">
                      <div class="access-image">
                        <NoAccessImage />
                      </div>
                      <div>
                        Sorry, you don't have access to this information.
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </section>
          </div>
        </div>

        <div class="mobile-accordion">
          <div
            class="card-header"
            id="headingSix"
            data-toggle="collapse"
            data-target="#collapseSix"
            aria-expanded="true"
            aria-controls="collapseSix"
            @click="setOpenedAccordion(6)"
            ref="fees-percentages"
          >
            <span class="mb-0">
              Fees & Percentages
            </span>
            <img src="../../assets/img/chevron-alt.svg" alt="chevron" class="chevron-alt" :class="{ rotate: expanded.includes(6) }" />
          </div>

          <div id="collapseSix" class="collapse" :class="{ 'show': jobTabStep === 6 }" aria-labelledby="headingSix" data-parent="#accordion-wrap" v-if="jobTabStep === 6">
            <!-- Show fees & percentages -->
            <section>
              <template v-if="hasAccess">
                <div class="row mb-3">
                  <div class="col-12">
                    <FeesPercentages
                      :cluster-fee="job.cluster_fee"
                      :cluster-percent="job.cluster_percent"
                      :loading="jobLoading"
                      :fee-change="job.fee_change"
                      :job-id="job.id"
                      @getJob="$emit('getJob')"
                    />
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="row">
                  <div class="container">
                    <div class="col-12 d-flex flex-column align-items-center justify-content-center">
                      <div class="access-image">
                        <NoAccessImage />
                      </div>
                      <div>
                        Sorry, you don't have access to this information.
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </section>
          </div>
        </div>
      </div>
      <div class="row mx-0 position-fixed hidden-buttons"
           v-if="editedField && isActive"
      >
        <div class="col pb-2 pt-2 text-right">
          <button type="button"
                  @click="discardJob"
                  class="btn btn-secondary ld-ext-right"
                  :class="loadingDiscardButton ? 'running' : ''"
          >
            Discard
            <div class="ld ld-ball ld-flip" />
          </button>
          <button v-if="$_can('jobs.update')"
                  class="btn btn-primary ld-ext-right"
                  :class="loadingButton ? 'running' : ''"
                  :disabled="buttonDisabled"
          >
            Save
            <div class="ld ld-ball ld-flip" />
          </button>
        </div>
      </div>
    </form>

    <messages v-if="showMessagesModal === true && carrierPhoneNumberCheck()"
              @toggleShowMessagesModal="toggleShowMessagesModal"
              :carrier-id="job.carrier_id"
              :carrier-number="job.carrier.phone_numbers.find(num => num.type.id === 2).phone_number"
              :model="'jobs'"
              :model-id="job.id"
              :selected-mover="selectedMoverId"
              :assigned-movers="job.assigned_movers"
    />
  </div>
</template>
<script>
import axios from 'axios';
import mapboxgl from 'mapbox-gl';
import toastr from 'toastr';
import { lineString, cleanCoords } from '@turf/turf';
import JobsLeadsAddresses from '../JobsLeadsAddresses';
import JobInProgressMoveTimeline from './JobInProgressMoveTimeline';
import JobsMapConnectionIssue from './JobsMapConnectionIssue';
import NoAccessImage from '../NoAccessImage';
import Distance from '../Distance';
import Messages from './modals/Messages';
import Job from '../../classes/Job';
import Errors from '../../classes/Errors';
import PhoneMask from '../../classes/PhoneMask';
import 'pusher-js';
import JobLogs from './JobLogs';
import UploadDocument from './subcomponents/UploadDocument';
import AreYouSureDeleteFile from './modals/AreYouSureDeleteFile.vue';
import JobPlans from './JobPlans.vue';
import FeesPercentages from '../FeesPercentages.vue';

export default {
  components: {
    FeesPercentages,
    JobPlans,
    AreYouSureDeleteFile,
    UploadDocument,
    JobLogs,
    Distance,
    JobInProgressMoveTimeline,
    JobsLeadsAddresses,
    JobsMapConnectionIssue,
    NoAccessImage,
    Messages,
  },
  props: {
    buttonDisabled: {
      type: Boolean,
      default: false,
    },
    deletedLocations: {
      type: Boolean,
      default: false,
    },
    editedField: {
      type: Boolean,
      default: false,
    },
    hasAccess: {
      type: Boolean,
      default: false,
    },
    job: {
      type: Object,
      default: () => {},
    },
    jobLoading: {
      type: Boolean,
      default: false,
    },
    jobTabStep: {
      type: Number,
      default: 1,
      required: true,
    },
    loadingDiscardButton: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    currentPosition: null,
    coordinates: [],
    loadingButton: false,
    loadingButtonMovers: [],
    map: null,
    mapLoading: false,
    markers: [],
    path: [],
    route: [],
    expanded: [1],
    selectedMoverId: null,
    showMessagesModal: false,
    switchedRoute: false,
    showTooltipPrefix: false,
    showTooltipMoversPrefix: false,
    showDisconnectError: false,
    truckMarker: null,
    timer: '',
    token: process.env.MAPBOX_TOKEN,
    showDropdown: [
      {
        0: false,
      },
    ],
    errors: new Errors(),
    phoneMask: new PhoneMask(),
    files: [],
    fileForDelete: null,
  }),
  computed: {
    isActive() {
      return (
        this.job.status &&
        this.job.status.name !== 'Canceled' &&
        this.job.status.name !== 'Completed'
      );
    },
    isCompleted() {
      return this.job.status && this.job.status.name === 'Completed';
    },
    showTimeline() {
      return Job.isJobInProgress(this.job.status_id) || this.job.status_id === 16;
    },
  },
  watch: {
    jobTabStep(newVal) {
      if (newVal === 2) {
        this.$nextTick(() => {
          if (!this.map || this.switchedRoute) {
            this.loadMap();
          } else if (this.map && this.switchedRoute) {
            this.updateRoute();
          }
          this.getDirections();
        });
      }
      if (newVal === 1) {
        this.getFiles();
      }
    },
    path(newVal) {
      if (newVal.length >= 2 && this.jobTabStep === 2) {
        this.getDirections();
      }
    },
    deletedLocations(newVal) {
      if (newVal === true) {
        this.getDirections();
      }
    },
  },
  mounted() {
    this.getPath(this.job);
    if (Job.isJobInProgress(this.job.status_id)) {
      this.bindSocket();
    }
    this.bindChannels(this);
    this.getFiles();
  },
  destroyed() {
    localStorage.removeItem('position');
  },
  methods: {
    setOpenedAccordion(value) {
      if (this.expanded.includes(value)) {
        const index = this.expanded.indexOf(value);
        if (index > -1) {
          this.expanded.splice(index, 1);
        }
      } else {
        this.expanded = [];
        this.expanded.push(value);
        if (value === 1) {
          this.$refs.addresses.scrollTop = 0;
          this.$nextTick(() => {
            this.$refs.addresses.scrollIntoView({ behavior: 'smooth' });
          });
        } else if (value === 2) {
          this.$refs.location.scrollTop = 0;
          this.$nextTick(() => {
            this.$refs.location.scrollIntoView({ behavior: 'smooth' });
          });
        } else if (value === 3) {
          this.$refs.movers.scrollTop = 0;
          this.$nextTick(() => {
            this.$refs.movers.scrollIntoView({ behavior: 'smooth' });
          });
        } else if (value === 5) {
          this.$refs.lans.scrollTop = 0;
          this.$nextTick(() => {
            this.$refs.plans.scrollIntoView({ behavior: 'smooth' });
          });
        } else {
          this.$refs.log.scrollTop = 0;
          this.$nextTick(() => {
            this.$refs.log.scrollIntoView({ behavior: 'smooth' });
          });
        }
      }
      this.$emit('jobTabStep', value);
    },
    getPath(job) {
      job.addresses.forEach(address => {
        if (address.full_address) {
          const type = address.type_id === 1 ? 'pickup' : 'delivery';
          this.coordinates.push([address.longitude, address.latitude, type]);
          this.path.push([address.longitude, address.latitude]);
        }
      });
    },
    bindChannels(vm) {
      window.echo.private(`job.${vm.job.id}`).listen('.jobUpdated', () => {
        vm.$emit('getJob');
        if (vm.job.status_id === 16) {
          vm.echo.leaveChannel(`job.${vm.job.id}`);
        }
      });
    },
    bindSocket() {
      window.echo.connector.pusher.connection.bind('unavailable', () => {
        this.showDisconnectError = true;
      });
      window.echo.connector.pusher.connection.bind('connecting', () => {
        this.showDisconnectError = true;
      });
      window.echo.connector.pusher.connection.bind('connected', () => {
        this.showDisconnectError = false;
      });
      window.echo.connector.pusher.connection.bind('error', () => {
        this.showDisconnectError = true;
      });
      const vm = this;
      window.echo.private(`job.${this.job.id}`).listenForWhisper('locationUpdated', position => {
        vm.currentPosition = position;
        localStorage.setItem('position', JSON.stringify(position));
        clearTimeout(vm.timer);
        vm.timer = setTimeout(() => {
          vm.showDisconnectError = true;
          vm.currentPosition = JSON.parse(localStorage.getItem('position'));
        }, 120000);
        if (vm.truckMarker) {
          vm.animateMarker();
        } else {
          const marker = document.createElement('div');
          marker.className = 'truck-marker';
          vm.truckMarker = new mapboxgl.Marker(marker)
            .setLngLat([vm.currentPosition.longitude, vm.currentPosition.latitude])
            .addTo(vm.map);
          vm.map.flyTo({
            center: [vm.currentPosition.longitude, vm.currentPosition.latitude],
            essential: true,
          });
        }
        vm.showDisconnectError = false;
        vm.updateTruckRoute();
      });
    },
    animateMarker() {
      if (this.currentPosition) {
        this.truckMarker.setLngLat([this.currentPosition.longitude, this.currentPosition.latitude]);
      }
    },
    updateRoute() {
      this.path = [];
      this.coordinates = [];
      this.getPath(this.job);
      this.switchedRoute = false;
    },
    updateTruckRoute() {
      if (this.currentPosition && this.route.geometry) {
        this.route.geometry.coordinates.push([
          this.currentPosition.longitude,
          this.currentPosition.latitude,
        ]);
        this.map.getSource('route').setData(this.route);
      }
    },
    switchRoute(param, index) {
      this.toggleEditField();
      this.switchedRoute = true;
      const temp = this.job.addresses[index];
      if (param === 'down') {
        this.$set(this.job.addresses, index, this.job.addresses[index + 1]);
        this.$set(this.job.addresses, index + 1, temp);
        this.updateRoute();
      } else {
        this.$set(this.job.addresses, index, this.job.addresses[index - 1]);
        this.$set(this.job.addresses, index - 1, temp);
        this.updateRoute();
      }
    },
    sendAutomaticMessages() {
      this.$emit('sendAutomaticMessages');
    },
    setAddress(address, index) {
      axios
        .get(
          `geocode?place_id=${encodeURIComponent(address.place_id)}&address=${encodeURIComponent(
            address.full_address,
          )}`,
        )
        .then(res => {
          [address] = res.data.data;
          const addressNew = Object.assign({ type_id: this.job.addresses[index].type_id }, address);
          this.$set(this.job.addresses, index, addressNew);
          this.switchedRoute = true;
          this.updateRoute();
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
      this.showDropdown[index] = false;
    },
    addAddress(type) {
      this.job.addresses.push({
        street_name: '',
        state: [
          {
            name: '',
          },
        ],
        state_id: 0,
        city: '',
        postal_code: '',
        apartment: '',
        type_id: type,
      });
      this.$nextTick(() => {
        window.$('input').attr('autocomplete', 'no');
        this.toggleEditField();
      });
    },
    removeAddress(index) {
      this.toggleEditField();
      this.errors.clear();
      this.job.addresses.splice(index, 1);
    },
    loadMap() {
      mapboxgl.accessToken = this.token;
      this.map = new mapboxgl.Map({
        container: 'mapid',
        style: 'mapbox://styles/lannito/ck85qs8tn0eml1ip6srfuvvdc',
        center: [this.job.addresses[0].longitude, this.job.addresses[0].latitude],
        minZoom: 2,
        zoom: 12,
      });
      this.switchedRoute = false;
    },
    getLocationsTracking(points) {
      if (this.map) {
        axios
          .get(`locations/tracking/${this.job.id}`)
          .then(res => {
            if (this.showTimeline && res.data && res.data.length) {
              this.coordinates.forEach(point => {
                const iconCircleWrapper = document.createElement('span');
                const iconWrapper = document.createElement('span');
                const pin = document.createElement('span');
                if (point[2] === 'delivery') {
                  iconCircleWrapper.className = 'icon-outer-circle';
                  iconWrapper.className = 'icon-check-wrapper';
                  pin.className = 'mod-icon-check';
                  iconWrapper.appendChild(pin);
                  iconCircleWrapper.appendChild(iconWrapper);
                } else {
                  iconCircleWrapper.className = 'icon-outer-circle';
                  iconWrapper.className = 'icon-flag-wrapper';
                  pin.className = 'mod-icon-flag';
                  iconWrapper.appendChild(pin);
                  iconCircleWrapper.appendChild(iconWrapper);
                }
                let popupText;
                if (point[2] === 'delivery') {
                  popupText = 'Delivery address';
                } else {
                  popupText = 'Pickup address';
                }
                const popup = new mapboxgl.Popup({
                  className: 'job-in-progress-popup',
                  closeButton: false,
                  closeOnClick: false,
                  anchor: 'bottom',
                  offset: 15,
                })
                  .setLngLat([point[0], point[1]])
                  .setText(popupText)
                  .addTo(this.map);
                if (popup.isOpen()) {
                  popup.remove();
                }
                this.markers.push(
                  new mapboxgl.Marker(iconCircleWrapper)
                    .setLngLat([point[0], point[1]])
                    .addTo(this.map)
                    .setPopup(popup),
                );
              });

              const bounds = this.coordinates.reduce((bound, coord) => {
                return bound.extend(coord);
              }, new mapboxgl.LngLatBounds(this.coordinates[0], this.coordinates[1]));
              this.map.fitBounds(bounds, {
                padding: 80,
                duration: 500,
              });

              const coordinates = res.data.map(point => [
                point.location.coordinates[0],
                point.location.coordinates[1],
              ]);
              if (coordinates.length > 1) {
                const line = lineString(coordinates);
                this.route = cleanCoords(line);
                if (!this.map.getSource('route')) {
                  this.map.addSource('route', {
                    type: 'geojson',
                    data: this.route,
                  });
                } else {
                  this.map.getSource('route').setData(this.route);
                }
                if (this.map.getLayer('route')) {
                  this.map.removeLayer('route');
                }
                this.map.addLayer({
                  id: 'route',
                  type: 'line',
                  source: 'route',
                  paint: {
                    'line-width': 4,
                    'line-color': '#2962ff',
                    'line-dasharray': [1, 2],
                  },
                  layout: {
                    'line-cap': 'round',
                  },
                });
              }
            } else {
              this.getDefaultRoute(points);
            }
          })
          .catch(() => {
            this.showDisconnectError = true;
          })
          .finally(() => {
            this.mapLoading = false;
          });
      }
    },
    getDirections() {
      this.mapLoading = true;
      const points = this.path.map(e => e.join(',')).join(';');

      if (points && points.length) {
        if (Job.isJobInProgress(this.job.status_id) || this.job.status_id === 16) {
          this.getLocationsTracking(points);
        } else {
          this.getDefaultRoute(points);
        }
      }
    },
    getDefaultRoute(points) {
      axios
        .get(
          `https://api.mapbox.com/directions/v5/mapbox/driving/${points}?&access_token=${
            this.token
          }&geometries=geojson`,
        )
        .then(res => {
          // Set source
          if (!this.map.getSource('directions')) {
            this.map.addSource('directions', {
              type: 'geojson',
              data: {
                type: 'Feature',
                geometry: res.data.routes[0].geometry,
              },
            });
          } else {
            // Update source
            this.map.getSource('directions').setData({
              type: 'Feature',
              geometry: res.data.routes[0].geometry,
            });
          }
          // Set layer
          if (!this.map.getLayer('route')) {
            this.map.addLayer({
              id: 'route',
              type: 'line',
              source: 'directions',
              paint: {
                'line-width': 4,
                'line-color': '#2962ff',
                'line-dasharray': [1, 2],
              },
              layout: {
                'line-cap': 'round',
              },
            });
            this.coordinates.forEach((point, index) => {
              this.map.addLayer({
                id: `point${index}`,
                type: 'circle',
                paint: {
                  'circle-color': '#000',
                },
                source: {
                  type: 'geojson',
                  data: {
                    type: 'Feature',
                    geometry: {
                      type: 'Point',
                      coordinates: [point[0], point[1]],
                    },
                  },
                },
              });
            });

            this.markers.forEach(marker => {
              marker.remove();
            });
            this.coordinates.forEach(point => {
              const el = document.createElement('span');
              if (point[2] === 'delivery') {
                el.className = 'marker-1';
              } else {
                el.className = 'marker-0';
              }
              let popupText;
              if (point[2] === 'delivery') {
                popupText = 'Delivery address';
              } else {
                popupText = 'Pickup address';
              }
              const popup = new mapboxgl.Popup({
                className: 'job-in-progress-popup',
                closeButton: false,
                closeOnClick: false,
                anchor: 'bottom',
                offset: 15,
              })
                .setLngLat([point[0], point[1]])
                .setText(popupText)
                .addTo(this.map);
              this.markers.push(
                new mapboxgl.Marker(el)
                  .setLngLat([point[0], point[1]])
                  .addTo(this.map)
                  .setPopup(popup),
              );
            });
          }
          const [coordinates] = res.data.routes;

          const bounds = coordinates.geometry.coordinates.reduce((localBounds, coord) => {
            return localBounds.extend(coord);
          }, new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]));

          this.map.once('loaded', () => {
            this.map.resize();
          });
          this.map.fitBounds(bounds, {
            padding: 25,
          });
        })
        .finally(() => {
          this.mapLoading = false;
        })
        .catch();
    },
    carrierPhoneNumberCheck() {
      return this.job.carrier
        ? this.job.carrier.phone_numbers.find(num => num.type.id === 2)
        : null;
    },
    sendMessages(mover = null, index = null) {
      if (index !== null) {
        this.$set(this.loadingButtonMovers, index, true);
      }
      this.loadingButton = true;
      if (mover) {
        this.selectedMoverId = mover.id;
      }
      const data = {};
      if (this.selectedMoverId) {
        data.mover_ids = [this.selectedMoverId];
      }
      axios
        .post(`movers/text-messages/${this.job.id}`, data)
        .then(() => {
          this.$emit('getJob');
          if (this.selectedMoverId) {
            toastr.success('Request for confirmation successfully sent to mover');
          } else {
            toastr.success('Request for confirmation successfully sent to all movers');
          }
        })
        .catch(err => {
          if (err.response.data) {
            if (err.response.data.error.carrier_phone) {
              toastr.error(err.response.data.error.carrier_phone);
            }
            this.errors.record(err.response.data.error);
          }
        })
        .finally(() => {
          this.selectedMoverId = null;
          this.$emit('buttonDisabled');
          this.loadingButton = false;
          if (index !== null) {
            this.loadingButtonMovers[index] = false;
          }
        });
    },
    unassignMover(id) {
      axios
        .delete(`/jobs/${this.$route.params.id}/movers`, {
          data: {
            movers: { id },
          },
        })
        .then(() => {
          this.$emit('getJob');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
    unassignTruck(id) {
      axios
        .delete(`/jobs/${this.$route.params.id}/trucks`, {
          data: {
            trucks: { id },
          },
        })
        .then(() => {
          this.$emit('getJob');
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    discardJob() {
      this.$emit('discardJob');
    },
    toggleShowMessagesModal(id) {
      this.selectedMoverId = id;
      this.showMessagesModal = !this.showMessagesModal;
      if (!this.showMessagesModal) {
        this.$emit('getJob');
      }
    },
    toggleEditField() {
      this.switchedRoute = true;
      this.$emit('editedField');
    },
    clearError(event) {
      this.errors.clear(event.target.name);
    },
    getFiles() {
      axios.get(`jobs/${this.job.id}/files`).then(res => {
        this.files = res.data.data;
      });
    },
    openFile(url) {
      window.open(url, '_blank');
    },
    updateFileCanCustomerSee(file) {
      axios
        .put(`/jobs/${this.job.id}/files/${file.id}`, {
          can_see_customer: !file.can_see_customer,
          order: file.order,
        })
        .then(() => {
          file.can_see_customer = !file.can_see_customer;
          toastr.success('Sucessfully updated file.');
        });
    },
  },
};
</script>
<style lang="scss">
@media screen and (max-width: 1450px) {
  .map-job-wrapper {
    position: relative;
    height: 500px;
    #mapid {
      width: 480px !important;
      height: 500px !important;
    }
  }
}
@media screen and (max-width: 1280px) {
  .map-job-wrapper {
    position: relative;
    height: 500px !important;
    #mapid {
      width: 300px !important;
      height: 500px !important;
    }
  }
}
@media screen and (max-width: 991px) {
  .map-job-wrapper {
    position: relative;
    height: 500px;
    #mapid {
      width: 480px !important;
      height: 500px !important;
    }
  }
}
@media screen and (max-width: 425px) {
  .map-job-wrapper {
    position: relative;
    height: 500px;
    #mapid {
      width: 300px !important;
      height: 500px !important;
    }
  }
}

.file-name {
  font-size: 13px;
  color: black;

  &:hover {
    text-decoration: none;
  }
}

.file-date {
  font-size: 11px;
  margin-top: 3px;
}

.cursor-pointer {
  cursor: pointer;
}

.documents-title {
  text-transform: uppercase;
  font-size: 13px;
  font-weight: bold;
  color: #6e6e72;
}

.file-card {
  position: relative;

  .buttons-box {
    display: none;
    z-index: 1000;
    position: absolute;
    right: 5px;
    height: 40px;
    align-items: center;

    .remove-file-block {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.file-card:hover {
  background-color: #bfbfc0;

  .buttons-box {
    display: flex;
  }

  .file-name {
    color: #2962ff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/JobsTabsContent.vue